import classNames = require("classnames");
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage";
import { SiteArticleSocialShareNew1280 } from "../../../article/componentas/articleSocialShare1280Component/articleSocialShareNew1280";
import { Logo } from "../../../ynet1280/ynetHeader/components/siteYnetHeaderComponenta";
import { MenuItems } from "./galhadHeaderComponenta";
import * as throttle from "lodash/throttle"
import { analyticsPushFunc, openWhatsAppShare } from "../../../../widgetsUtils";
import { FontSlider } from "../../../ynet1280/ynetHeader/components/mutamComponents/fontSliderComponent";


interface Props {
    menuLogosItems: MenuItems[]
    menuItems: MenuItems[]
    sitename: string
    isApp: boolean
    isArticlePage: boolean
    logoData: Logo
    domain: string


}

interface State {
    isSticky: boolean
    isFontMenuOpen: boolean
}
export class GalhadHeaderMobileComponenta extends React.Component<Props, State> {
    public static siteScriptName = "GalhadHeaderMobileComponenta"
    constructor(props) {
        super(props)
        this.state = {
            isSticky: false,
            isFontMenuOpen: false
        }
    }
    private stickyBar() {
        let element = document.getElementById('ArticleBodyComponent');
        const headerContainerPos = document.querySelector(".galhad-header").getBoundingClientRect().top;
        const headerPos = document.querySelector(".GalhadHeaderComponenta") ? document.querySelector(".GalhadHeaderComponenta").getBoundingClientRect().top : 0;;
        let isSticky = element ? headerContainerPos + 40 < 0 : headerPos + 40 < 0;

        if (isSticky) {
            this.setState({ isSticky: true });


        } else {
            this.setState({ isSticky: false })
        }

    }
    componentDidMount() {
        document.addEventListener("scroll", this.throttledScrollHandler())
        this.props.isArticlePage && this.setfontSize();
    }
    private setfontSize = () => {
        if (localStorage && localStorage.fontSize) {
            let size = localStorage.fontSize;
            document.documentElement.style.fontSize = size * parseInt(getComputedStyle(document.documentElement).fontSize) + "px";
        }

    }



    componentWillUnmount() {

        document.removeEventListener("scroll", this.throttledScrollHandler())

    }
    private throttledScrollHandler = () => throttle(() => this.stickyBar(), 200)

    private openShare = async () => {
        const { domain } = this.props;
        const current_url = `${window.location.href}?utm_source=${domain}&utm_medium=social&utm_campaign=general_share`;
        const shareData = { url: current_url }
        try {
            // @ts-ignore 
            await navigator.share(shareData)
        } catch (err) {
            console.log("error with sharing function", err);
        }
    }


    private showCommentsBtn = () => {
        return typeof window !== "undefined" && (window.handleCommentsPopupVisability);

    }
    private handleFontSizePopupVisability = () => {
        this.setState({ isFontMenuOpen: true })
    }
    private handleFontSizePopupClose = () => {
        this.setState({ isFontMenuOpen: false })
    }
    private clickAcessibilityBtn = () => {
        window[`EquallyAI`] && window[`EquallyAI`].openToolbox();
        window[`interdeal`] && window[`interdeal`][`a11y`] && window[`interdeal`][`a11y`].openMenu();
    }

    render() {
        const { menuLogosItems, menuItems, sitename, isApp, isArticlePage, logoData } = this.props
        const { isSticky, isFontMenuOpen } = this.state
        const isAppNative =   isApp || (typeof window !== "undefined" && window.location.href.indexOf("isAppNative") != -1);
        const isPageApp = (typeof window !== "undefined" &&   window.location.href.indexOf("IsApp") != -1);
        const tooltipHidden = !isSticky ? "hidden" : "";
        const url = typeof window !== "undefined" && isArticlePage && window.location.href;

        return (<div className="GalhadMobileHeader">
            {!isAppNative ? <div className={classNames("GalhadHeaderComponenta", { "notStickyHeader": !isSticky, "Article": isArticlePage })} >
               <a href={"javascript:history.back()"} className={`goBack ${isPageApp ? "hidden" : ""}`} title="back" />
                {(!isSticky || !isArticlePage) &&
                    <>
                        <div className={`logo`}>
                            <HyperLinkBuilder href={logoData.link} linkTarget={logoData.linkTarget} ariaLabel={logoData.mediaTitle}>
                                <div className="darkModeLogo" aria-label="Page Logo" title="לוגו אתר YNET" alt="לוגו אתר YNET"></div>
                            </HyperLinkBuilder>

                        </div>
                        <button className="topBtns mobileShareBtn" onClick={this.openShare} title={"share"} />
                    </>}
                {isArticlePage && <div className={`btnTooltips ${tooltipHidden}`} >
                    <button className="topBtns fontSizeMenuOpen" onClick={this.handleFontSizePopupVisability}></button>
                    <button className="topBtns accessibiltyBtn" onClick={this.clickAcessibilityBtn} title="אתר נגיש" aria-labelledby="INDbtnTooltip" accessKey="m"></button>
                    <div className="topBtns whatsAppShareBtn" onClick={() => openWhatsAppShare(url, () => analyticsPushFunc("Whatsapp", "Article"), "Article Top")}></div>
                    <button className="topBtns mobileShareBtn" onClick={this.openShare} title={"share"} />
                    <button style={{ display: this.showCommentsBtn() ? "block" : "none" }} className="topBtns commentsOpen" id="commentButtonInHeader" ></button>

                </div>}
                {isFontMenuOpen && <FontSlider onClose={this.handleFontSizePopupClose} lang={sitename === "ynetnews" ? "en" : "he"} />}
            </div> : <div className="GalhadHeaderAppComponenta"></div>}
            {menuItems && menuItems.length >= 1 && menuItems[0].title && menuItems[0].title.length > 0 && <div className="navLinks">
                {_.map(menuItems, (item, index) => {
                    return (
                        <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} className="sideLink" key={index}>
                            {item.title}
                        </HyperLinkBuilder>

                    )
                })}
            </div>}
        </div>
        )

    }
}

//isArticlePage